<div class="dashboard-page">
  <div class="top">
    <h1 class="title">
      Hola, {{ user?.nombre }}.
      <mat-icon class="wave">waving_hand</mat-icon>
    </h1>

    <!-- BUSCADOR MÉDICO / ADMINISTRADOR -->
    @if (tieneRol('MEDIC@') || tieneRol('ADMIN')) {
      <div class="buscador-acciones">
        <div class="buscar-paciente-panel">
          <div class="buscador-container buscador-flotante">
            <mat-form-field appearance="outline" class="search-box">
              <mat-label>Buscar paciente</mat-label>

              <input
                #buscador
                matInput
                type="text"
                placeholder="Nombre del paciente"
                [(ngModel)]="busqueda"
                (input)="alEscribirBusqueda()"
                (focus)="mostrarResultadosBusqueda = true"
                (keydown.escape)="limpiarBusqueda(buscador)"
              />

              @if (busqueda) {
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  aria-label="Limpiar búsqueda"
                  (click)="limpiarBusqueda(buscador)"
                >
                  <mat-icon>close</mat-icon>
                </button>
              } @else {
                <mat-icon matSuffix>search</mat-icon>
              }
            </mat-form-field>
          </div>

          <!-- RESULTADOS FLOTANTES -->
          @if (mostrarResultadosBusqueda && busqueda.trim() && pacientesFiltrados.length > 0) {
            <div class="resultados">
              @for (paciente of pacientesFiltrados; track paciente.id) {
                <div class="paciente-item">
                  <div class="paciente-info">
                    <h3>
                      {{ paciente.nombre }}
                      {{ paciente.apellido }}
                      {{ paciente.segundoApellido }}
                    </h3>

                    <p>Tel: {{ paciente.telefono }}</p>
                  </div>

                  <button
                    mat-flat-button
                    class="add-boton add-boton--flexible"
                    (click)="abrirRegistroSignosVitales(paciente)"
                  >
                    <mat-icon>monitor_heart</mat-icon>
                    Registrar signos vitales
                  </button>
                </div>
              }
            </div>
          }

          <!-- SIN RESULTADOS -->
          @if (mostrarResultadosBusqueda && busqueda.trim() && pacientesFiltrados.length === 0) {
            <div class="sin-resultados">
              <p>No se encontraron pacientes.</p>
            </div>
          }
        </div>

        <button mat-flat-button class="add-boton add-boton--grande" (click)="abrirNuevoPaciente()">
          <mat-icon>person_add</mat-icon>
          Nuevo paciente
        </button>
      </div>
    }
  </div>

  <!-- TARJETAS DEL DASHBOARD -->
  <app-dashboard-cards
    class="dashboard-cards-wrapper"
    [pendientes]="pendientes.length"
    [consultasHoy]="consultasHoy"
    [restantes]="restantes"
    [proximaConsulta]="proximaConsulta"
    [rol]="user?.rol?.nombre"
    [totalPendientes]="pendientes.length"
    (verDetalle)="abrirPacientesAtendidos()"
    (verTodos)="abrirTodosPendientes()"
    (consultaCancelada)="cargarAtenciones()"
  >
  </app-dashboard-cards>

  <!-- DETALLE MÉDICO / ADMINISTRADOR -->
  @if (tieneRol('MEDIC@') || tieneRol('ADMIN')) {
    <app-dashboard-detail
      class="dashboard-detail-wrapper"
      [pendientes]="pendientes"
      [totalPendientes]="pendientes.length"
      (verPendientes)="abrirTodosPendientes()"
      (verTodos)="abrirTodosPendientes()"
      (consultaCancelada)="cargarAtenciones()"
    >
    </app-dashboard-detail>
  }

  <!-- ENFERMERÍA -->
  @if (tieneRol('ENFERMER@')) {
    <div class="enfermeria-panel">
      <h2>Buscar paciente</h2>

      <div class="buscador-container">
        <mat-form-field appearance="outline" class="search-box" subscriptSizing="dynamic">
          <mat-label>Buscar paciente</mat-label>

          <input
            #buscadorEnfermeria
            matInput
            type="text"
            placeholder="Nombre del paciente"
            [(ngModel)]="busqueda"
            (input)="filtrarPacientes()"
            (keydown.escape)="limpiarBusqueda(buscadorEnfermeria)"
          />

          @if (busqueda) {
            <button
              mat-icon-button
              matSuffix
              type="button"
              aria-label="Limpiar búsqueda"
              (click)="limpiarBusqueda(buscadorEnfermeria)"
            >
              <mat-icon>close</mat-icon>
            </button>
          } @else {
            <mat-icon matSuffix>search</mat-icon>
          }
        </mat-form-field>

        <button mat-flat-button class="add-boton add-boton--grande" (click)="abrirNuevoPaciente()">
          <mat-icon>person_add</mat-icon>
          Nuevo paciente
        </button>
      </div>

      @if (pacientesFiltrados.length > 0) {
        <div class="resultados">
          @for (paciente of pacientesFiltrados; track paciente.id) {
            <div class="paciente-item">
              <div>
                <h3>
                  {{ paciente.nombre }}
                  {{ paciente.apellido }}
                  {{ paciente.segundoApellido }}
                </h3>

                <p>Tel: {{ paciente.telefono }}</p>
              </div>

              <button
                mat-flat-button
                class="add-boton add-boton--flexible"
                (click)="abrirRegistroSignosVitales(paciente)"
              >
                <mat-icon>monitor_heart</mat-icon>
                Registrar signos vitales
              </button>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
